import React from "react";
import { useNavigate } from "react-router-dom";

import CurrentActiveBtn from "../../shared/CurrentActiveBtn";
import CurrentBannedBtn from "../../shared/CurrentBannedBtn";
import CuurentStateBtn from "../../shared/CuurentStateBtn";

const BusinessRow = ({ rowData, index, isApproved }) => {
  const navigate = useNavigate();

  const handleBusinessInfo = (id) => {
    navigate(`/business/${rowData?.business_type}/${id}`);
  };

  return (
    <div
      onClick={() => handleBusinessInfo(rowData?.id)}
      className="w-full bg-neutral-10 rounded-v-lg mt-2 cursor-pointer"
    >
      <div className="w-full grid grid-cols-[.25fr_1fr_1fr_1fr_1fr_1fr_1fr_1fr]   py-1 whitespace-nowrap text-neutral-90 mt-2  px-2 text-title-sm-regular">
        <div className="flex justify-center items-center">{index + 1}</div>
        <div dir="rtl" className=" text-center  max-w-[200px] truncate">
          {rowData?.fa_name}
        </div>
        <div className="flex justify-center items-center">
          {rowData.business_type === "real" ? "حقیقی" : "حقوقی"}
        </div>
        <p
          className="flex justify-start items-center max-w-[200px]  truncate "
          title={rowData.category_title}
        >
          {rowData.category_title}
        </p>
        {isApproved ? (
          <div className="flex justify-center items-center">
            {Number(rowData.available_balance).toLocaleString()}
          </div>
        ) : (
          <div className="flex justify-center items-center"></div>
        )}
        <div className="flex justify-center items-center">
          <CuurentStateBtn state={rowData.approval_status} />
        </div>
        <div className="flex justify-center items-center">
          <CurrentActiveBtn state={rowData.active} />
        </div>
        <div className="flex justify-center items-center">
          <CurrentBannedBtn state={rowData.banned} />
        </div>
      </div>
    </div>
  );
};

export default BusinessRow;
